<div class="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md mt-6">
    <div class="flex items-center gap-4 mb-8">
        <a routerLink="/admin/supplier-payments" class="text-gray-500 hover:text-gray-700 transition-colors">
            &larr; Voltar
        </a>
        <h2 class="text-3xl font-bold text-gray-800">Detalhe da Transação</h2>
    </div>

    <div *ngIf="loading" class="text-center py-12 text-gray-500 text-lg">
        Carregando detalhes...
    </div>

    <div *ngIf="!loading && item" class="space-y-8">
        <!-- Header Actions -->
        <div class="flex justify-between items-start bg-gray-50 p-6 rounded-lg border border-gray-200">
            <div>
                <h3 class="text-lg font-bold text-gray-900 mb-1">Status: <span
                        [class]="getStatusClass(item.status) + ' px-3 py-1 rounded text-sm ml-2'">{{
                        getStatusLabel(item.status) }}</span></h3>
                <p class="text-sm text-gray-500 mt-2">Transação: <span class="font-mono text-gray-700">{{ item.id
                        }}</span></p>
            </div>

            <div class="flex gap-2" *ngIf="item.status === 'AWAITING_PAYMENT'">
                <button (click)="confirmar()" [disabled]="processingAction"
                    class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50">
                    Confirmar Manual
                </button>
                <button (click)="cancelar()" [disabled]="processingAction"
                    class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50">
                    Cancelar
                </button>
                <button (click)="expirar()" [disabled]="processingAction"
                    class="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors disabled:opacity-50">
                    Expirar
                </button>
            </div>
        </div>

        <!-- Financial Details -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="p-6 border border-gray-100 rounded-lg hover:shadow-sm transition-shadow">
                <h3 class="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                        <path fill-rule="evenodd"
                            d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
                            clip-rule="evenodd" />
                    </svg>
                    Detalhes Financeiros
                </h3>
                <dl class="space-y-3">
                    <div class="flex justify-between border-b border-gray-100 pb-2">
                        <dt class="text-sm text-gray-500">Preço Base</dt>
                        <dd class="text-sm font-medium text-gray-900">R$ {{ item.basePrice | number:'1.2-2' }}</dd>
                    </div>
                    <div class="flex justify-between border-b border-gray-100 pb-2">
                        <dt class="text-sm text-gray-500">Desconto</dt>
                        <dd class="text-sm font-medium text-green-600">- R$ {{ item.discountAmount | number:'1.2-2' }}
                        </dd>
                    </div>
                    <div class="flex justify-between border-b border-gray-100 pb-2 bg-gray-50 p-2 rounded">
                        <dt class="text-base font-bold text-gray-800">Preço Final</dt>
                        <dd class="text-base font-bold text-indigo-600">R$ {{ item.finalPrice | number:'1.2-2' }}</dd>
                    </div>
                    <div class="flex justify-between border-b border-gray-100 pb-2" *ngIf="item.couponCode">
                        <dt class="text-sm text-gray-500">Cupom</dt>
                        <dd class="text-sm font-medium text-gray-900 bg-yellow-100 px-2 rounded">{{ item.couponCode }}
                        </dd>
                    </div>
                </dl>
            </div>

            <!-- Dates & Provider -->
            <div class="p-6 border border-gray-100 rounded-lg hover:shadow-sm transition-shadow">
                <h3 class="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                            clip-rule="evenodd" />
                    </svg>
                    Prazos e Fornecedor
                </h3>
                <dl class="space-y-3">
                    <div class="flex justify-between border-b border-gray-100 pb-2">
                        <dt class="text-sm text-gray-500">Criado em</dt>
                        <dd class="text-sm font-medium text-gray-900">{{ item.createdAt | date:'medium' }}</dd>
                    </div>
                    <div class="flex justify-between border-b border-gray-100 pb-2">
                        <dt class="text-sm text-gray-500">Expira em</dt>
                        <dd class="text-sm font-medium text-red-600">{{ item.expiresAt | date:'medium' }}</dd>
                    </div>
                    <div class="flex justify-between border-b border-gray-100 pb-2" *ngIf="item.paidAt">
                        <dt class="text-sm text-gray-500">Pago em</dt>
                        <dd class="text-sm font-medium text-green-600">{{ item.paidAt | date:'medium' }}</dd>
                    </div>
                    <div class="mt-4 pt-2">
                        <dt class="text-xs text-gray-500 uppercase tracking-wide mb-1">Fornecedor</dt>
                        <dd class="text-sm font-medium text-gray-900 border l-4 border-l-4 border-indigo-500 pl-3">
                            {{ item.fornecedorNome }}<br>
                            <span class="text-gray-400 font-mono text-xs">{{ item.fornecedorId }}</span>
                        </dd>
                    </div>
                </dl>
            </div>
        </div>

        <div class="bg-gray-50 p-6 rounded-lg border border-gray-200"
            *ngIf="item.checkoutUrl && item.status === 'AWAITING_PAYMENT'">
            <h3 class="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2">Link de Checkout</h3>
            <a [href]="item.checkoutUrl" target="_blank"
                class="text-indigo-600 hover:text-indigo-800 break-all underline">
                {{ item.checkoutUrl }}
            </a>
        </div>

        <div class="bg-red-50 p-6 rounded-lg border border-red-200" *ngIf="item.cancelledAt">
            <h3 class="text-sm font-bold text-red-800 uppercase tracking-wider mb-2">Cancelado</h3>
            <p class="text-red-700">Esta transação foi cancelada em {{ item.cancelledAt | date:'medium' }}.</p>
        </div>
    </div>
</div>